exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".curr-month-overview[data-v-7daba081] {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 10px;\n}\n.curr-month-overview .tip[data-v-7daba081] {\n  padding: 15px;\n  border-radius: 10px;\n  line-height: 1.8;\n  background-color: #fdfde5;\n}\n", ""]);

// exports
